<script setup>
import { reactive, computed } from 'vue'
import { useRouter } from 'vue-router'
import PasswordResetSet from '../components/PasswordResetSetComponent.vue'
import Cognito  from '../utils/cognito.js'

const router = useRouter()
const passReset = reactive({
  email: '',
  isSubmitting: false,
  showConfirmForm: false,
})

// 送信ボタン 活性 / 非活性判定
const isDisabled = computed(() => !passReset.email || passReset.isSubmitting)

// 認証コードをメールする
const sendEmail = async() => {
  if (passReset.email == '') {
    alert('メールアドレスを入力してください。')
    return
  }
  passReset.isSubmitting = true //送信ボタンを非活性にする

  // 認証コード送信のため、CognitoのAPI呼び出し
  try{
    await Cognito.forgotCognitoPass(passReset.email);
    // パスワード再設定画面を表示
    passReset.isSubmitting = false
    passReset.showConfirmForm = true
  } catch (err) {
    alert('認証コードの送信に失敗しました。')
    passReset.isSubmitting = false
  }
}
// パスワード再設定完了
const handleCompleted = () => {
  alert('パスワードの再設定が完了しました。ログイン画面へ戻ります。')
  router.replace({ name: 'login' })
}
</script>

<template>
  <main>
    <div class="userPassword">
        <div class="titleArea">
          <p class="title">{{ passReset.showConfirmForm ? '' : 'パスワード再設定' }}</p>
        </div>
        <table class="commonTable" v-if="!passReset.showConfirmForm">
          <tbody>
            <tr>
              <th></th>
            </tr>
            <tr>
              <td class="firstTd">メールアドレス</td>
            </tr>
            <tr>
              <td class="firstTd notTop">
                <input
                  type="email"
                  v-model="passReset.email"
                  class="inputText"
                  placeholder="認証コードを送るメールアドレスを入力"
                  autocomplete="email"
                />
              </td>
            </tr>
            <tr>
              <td class="updateArea">
                <button
                  type="button"
                  class="nextButton"
                  id="sendMailButton"
                  :disabled="isDisabled"
                  @click="sendEmail"
                >
                  {{ passReset.isSubmitting ? '送信中...' : '送信する' }}
                </button>
                <div class="returnLogin">
                  <router-link :to="{name: 'login'}">ログイン画面へ戻る</router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
    <PasswordResetSet
        v-if="passReset.showConfirmForm"
        :email="passReset.email"
        @completed="handleCompleted"
        @back="passReset.showConfirmForm = false"
      />
    </div>
  </main>
</template>

<style scoped>
.userPassword {
  padding: 0 20% 0 20%;
  background-color: #e7e6e6;
}
.titleArea .title {
  text-align: center;
  font-size: 40px;
  padding: 20px 0 0;
}
.inputText{
    border: 1px solid #969292;
    border-radius: 5px;
    background-color: white;
    text-align: left;
    width:70%;
}
.updateArea {
  margin-top: 20px;
  padding: 20px 0;
  text-align: center;
}
.errorMessage p {
  color: red;
  margin: 0;
}
.returnLogin{
    margin:15px 0;
}
#sendMailButton{
  width:60%;
}
    
@media (max-width: 1150px) {
  .userPassword {
    padding: 0 10% 0 10%;
  }
  .inputText {
    width: 80%;
  }
  .titleArea .title {
    font-size: 32px;
  }
}
@media (max-width: 768px) {
  .userPassword {
    padding: 0 5% 0 5%;
  }
  .titleArea .title {
    font-size: 28px;
  }
}
@media (max-width: 540px) {
  .userPassword {
    padding: 0 4% 0 4%;
  }
  .titleArea .title {
    font-size: 24px;
  }
}
</style>
